import { Api } from 'api/commissionEnv'
var api = new Api()
export default {
    // dailyReport: {
    //   link: 'dailyReport',
    //   set: false,
    //   icon: 'icon-copy'
    // },
    userList: {
        Role_ID: "A0001",
        link: '/userList',
        set: false,
        icon: 'icon-stack2',
        show: true,
    },
    authList: {
        Role_ID: "A0002",
        link: '/authList',
        set: false,
        icon: 'el-icon-warning',
        show: true,
    },
    // accountList: {
    //     Role_ID: "A0003",
    //     link: '/accountList',
    //     set: false,
    //     icon: 'icon-stack',
    //     show: true,
    // },
    // relation: {
    //     Role_ID: "A0004",
    //     link: '/relation',
    //     set: false,
    //     icon: 'icon-sort-amount-asc',
    //     show: true,
    // },
    // loginSalePlatform: {
    //     Role_ID: "A0005",
    //     link: "/loginSalePlatform",
    //     set: false,
    //     icon: 'glyphicon glyphicon-user',
    //     show: true,
    // },
    // changeParentSales: {
    //     Role_ID: "A0006",
    //     link: "/changeParentSales",
    //     set: false,
    //     icon: 'glyphicon glyphicon-pencil',
    //     show: true,
    // },
    // clientParentInfo: {
    //     Role_ID: "A0011",
    //     link: "/clientParentInfo",
    //     set: false,
    //     icon: 'glyphicon glyphicon-pencil',
    //     show: true,
    // },
    // commissionView: {
    //     Role_ID: "A0007",
    //     link: '/commissionView',
    //     set: false,
    //     icon: 'glyphicon glyphicon-cog',
    //     show: api.commissionEnable,
    // },
    commissionView_v2: {
        Role_ID: "A0011",
        link: "/commissionView_v2",
        set: false,
        icon: 'glyphicon glyphicon-cog',
        show: true,
    },
    profitShareView: {
        Role_ID: "A0008",
        link: '/profitShareView',
        set: false,
        icon: 'glyphicon glyphicon-file',
        show: api.commissionEnable,
    },
    changepswd: {
        Role_ID: "A0009",
        link: "/changepswd",
        set: false,
        icon: 'glyphicon glyphicon-cog',
        show: true,
    },
    logOut: {
        Role_ID: "A0010",
        link: 'logOut',
        set: false,
        icon: 'glyphicon glyphicon-off',
        show: true,
    },
}



// WEBPACK FOOTER //
// ./src/MultiLanguage/menuAllList.js